import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalToastService {
  message = '';
  show = false;
  type = '';
  delay = 5000;

  showToast(msg: any, type: any, delay: number = 5000) {
    console.log(type)
    this.message = msg;
    this.type = type;
    this.delay = delay;
    this.show = true;
    console.log(this.type)

    setTimeout(() => this.hideToast(), delay);
  }

  hideToast() {
    this.show = false;
  }
}
